class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }




class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];

    // 🔥 ADD CART PAGE SECTIONS
    if (document.getElementById('main-cart-items')) {
      sections.push(
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        }
      );
    }

    return sections;
  }
}


customElements.define('cart-drawer-items', CartDrawerItems);

// start here //


// function refreshCartDrawer() {

//   fetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-items')
//     .then(res => res.json())
//     .then(sections => {

//       /* ===============================
//          1. UPDATE DRAWER INNER ONLY
//       ================================ */

//       const drawer = document.querySelector('cart-drawer');

//       if (drawer && sections['cart-drawer']) {

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

//         const newInner = doc.querySelector('#CartDrawer .drawer__inner');
//         const currentInner = drawer.querySelector('.drawer__inner');

//         if (newInner && currentInner) {
//           currentInner.innerHTML = newInner.innerHTML;
//         }

//         drawer.classList.add('active');
//         document.body.classList.add('overflow-hidden');
//       }


//       /* ===============================
//          2. UPDATE ONLY CART COUNT NUMBER
//       ================================ */

//       if (sections['cart-icon-bubble']) {

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');

//         const newCount = doc.querySelector('.cart-count-bubble');
//         const currentCount = document.querySelector('.cart-count-bubble');

//         if (newCount && currentCount) {
//           currentCount.innerHTML = newCount.innerHTML;
//           currentCount.classList.remove('hidden');
//         }
//       }

      


//       /* ===============================
//          3. UPDATE CART PAGE IF EXISTS
//       ================================ */

//       const mainCartItems = document.querySelector('#main-cart-items');

//       if (mainCartItems && sections['main-cart-items']) {

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(sections['main-cart-items'], 'text/html');

//         const newMain = doc.querySelector('#main-cart-items .js-contents');
//         const currentMain = mainCartItems.querySelector('.js-contents');

//         if (newMain && currentMain) {
//           currentMain.innerHTML = newMain.innerHTML;
//         }
//       }

//     })
//     .catch(error => console.error('Cart refresh error:', error));
// }

// function refreshCartDrawer() {
//   fetch('/?sections=cart-drawer,cart-icon-bubble')
//     .then(res => res.json())
//     .then(sections => {

//       const drawer = document.querySelector('cart-drawer');

//       if (drawer && typeof drawer.renderContents === 'function') {
//         drawer.renderContents({
//           sections: sections
//         });

//         drawer.open();
//       }
//     });
// }


function refreshCartDrawer() {
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(res => res.json())
    .then(sections => {

      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({
          sections: sections
        });
      }

      // 🔥 Manually update cart icon bubble (IMPORTANT)
      const bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
      if (bubbleSection && sections['cart-icon-bubble']) {
        bubbleSection.innerHTML = sections['cart-icon-bubble'];
      }

      if (drawer) drawer.open();
    });
}
// function refreshCartDrawer() {

//   console.log('neeti');
//   // Fetch all cart-related sections at once
//   fetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-items')
//     .then(res => res.json())
//     .then(sections => {
//       // 1. Update Cart Drawer if it exists
//       const drawer = document.querySelector('cart-drawer');
//       if (drawer && sections['cart-drawer']) {
//         // Parse the new drawer HTML
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = sections['cart-drawer'];
        
//         // Update cart-drawer-items
//         const cartDrawerItems = drawer.querySelector('cart-drawer-items');
//         const newCartDrawerItems = tempDiv.querySelector('cart-drawer-items');
//         if (cartDrawerItems && newCartDrawerItems) {
//           cartDrawerItems.innerHTML = newCartDrawerItems.innerHTML;
//         }
        
//         // Update cart drawer footer
//         const cartDrawerFooter = drawer.querySelector('.cart-drawer__footer');
//         const newCartDrawerFooter = tempDiv.querySelector('.cart-drawer__footer');
//         if (cartDrawerFooter && newCartDrawerFooter) {
//           cartDrawerFooter.innerHTML = newCartDrawerFooter.innerHTML;
//         }
        
//         // Update any other drawer sections you might have
//         const drawerInnerEmpty = drawer.querySelector('.drawer__inner-empty');
//         const newDrawerInnerEmpty = tempDiv.querySelector('.drawer__inner-empty');
//         if (drawerInnerEmpty && newDrawerInnerEmpty) {
//           drawerInnerEmpty.innerHTML = newDrawerInnerEmpty.innerHTML;
//         }
//       }
      
//       // 2. Update Main Cart Items if on cart page
//       const mainCartItems = document.querySelector('#main-cart-items cart-items');
//       if (mainCartItems && sections['main-cart-items']) {
//         // Parse main cart items
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = sections['main-cart-items'];
//         const newCartItems = tempDiv.querySelector('cart-items');
//         if (newCartItems) {
//           mainCartItems.innerHTML = newCartItems.innerHTML;
//         }
//       }
      
//       // 3. Update Cart Icon Bubble
//       const bubble = document.querySelector('#cart-icon-bubble');
//       if (bubble && sections['cart-icon-bubble']) {
//         bubble.innerHTML = sections['cart-icon-bubble'];
//       }
      
//       // 4. Update Custom Cart References
//       const customCartRefs = document.querySelector('.custom-cart-refs');
//       if (customCartRefs) {
//         customCartRefs.classList.add('is-visible');
//       }
      
//       // 5. Update cart count in header if needed
//       const headerCartCount = document.querySelector('.header__icon--cart .count');
//       if (headerCartCount) {
//         // Extract count from bubble or update as needed
//         const newCount = bubble ? bubble.querySelector('.count') : null;
//         if (newCount) {
//           headerCartCount.textContent = newCount.textContent;
//         }
//       }
      
//       // 6. Trigger any cart update events for other components
//       if (window.PUB_SUB_EVENTS && window.publish) {
//         publish(PUB_SUB_EVENTS.cartUpdate, { 
//           source: "refresh-function",
//           cartData: null 
//         });
//       }
      
//       console.log('Cart refreshed successfully');
//     })
//     .catch(e => console.error('Error refreshing cart:', e));
// }


// end here //


// function refreshCartDrawer() {
//   fetch('/?sections=cart-drawer,cart-icon-bubble')
//     .then(res => res.json())
//     .then(sections => {
//       const drawer = document.querySelector('cart-drawer');
//       const bubble = document.querySelector('#cart-icon-bubble');
//             const customCartRefs = document.querySelector('.custom-cart-refs');


//       if (drawer) {
//         drawer.innerHTML = sections['cart-drawer'];
//         drawer.classList.add('active');
//       }
//             if (customCartRefs) {
//         customCartRefs.classList.add('is-visible');
//       }


//       if (bubble) {
//         bubble.innerHTML = sections['cart-icon-bubble'];
//       }

//        document.body.classList.add('overflow-hidden');

//     });
// }

// function refreshCartDrawer() {
//   fetch('/?sections=cart-drawer&sections=cart-icon-bubble')
//     .then(res => res.json())
//     .then(sections => {

//       // CART DRAWER
//       const drawer = document.querySelector('cart-drawer');
//       if (drawer && sections['cart-drawer']) {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

//         const newDrawerInner = doc.querySelector('cart-drawer').innerHTML;
//         drawer.innerHTML = newDrawerInner;

//         drawer.classList.add('active');
//         document.body.classList.add('overflow-hidden');
//       }

//       // CART ICON BUBBLE
//       const bubble = document.querySelector('#cart-icon-bubble');
//       if (bubble && sections['cart-icon-bubble']) {
//         bubble.innerHTML = sections['cart-icon-bubble'];
//       }

//       // CUSTOM CART REFS
//       const customCartRefs = document.querySelector('.custom-cart-refs');
//       if (customCartRefs) {
//         customCartRefs.classList.add('is-visible');
//       }
//     });
// }
